import { render, staticRenderFns } from "./paiement.html?vue&type=template&id=1151d7ec&scoped=true&external"
import script from "./paiement.js?vue&type=script&lang=js&external"
export * from "./paiement.js?vue&type=script&lang=js&external"
import style0 from "./paiement.scss?vue&type=style&index=0&id=1151d7ec&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1151d7ec",
  null
  
)

export default component.exports